var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WtButton',{staticClass:"make-an-entry",nativeOn:{"click":function($event){return _vm.openModal($event)}}},[_vm._v("Add New Entry")])}
var staticRenderFns = []

export { render, staticRenderFns }